import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '@plugin/settings';
import { DatabaseCollectionProvider } from '@core/database';

@Injectable({
    providedIn: 'root'
})
export class PodcastActivityService {
    private endpoint?: string;


    constructor(
        private http: HttpClient,
        private settings: AppSettings,
        private dbProvider: DatabaseCollectionProvider,
    ) {}

    async initData() {
        const domain = await this.dbProvider.getApiDomain();
        const protocol = await this.dbProvider.getProtocol();
        const internalId = this.settings.get('internalId');
        this.endpoint = `${protocol}://${domain}/api/Patients/${internalId}/podcastActivity`;
    }

    async saveActivity(activity: PodcastActivity): Promise<boolean> {
        if (!this.endpoint) {
            await this.initData();
        }

        return await this.http.post(this.endpoint, activity).toPromise().then(() => true).catch(() => false);
    }
}

export interface PodcastActivity {
    id?: string;
    type: string;
    file: string;
    createdAt: Date;
    data: any;
}
